'use client';

import { cva, type VariantProps } from 'class-variance-authority';
import { HTMLAttributes } from 'react';

const dividerVariants = cva('w-full border-none', {
  variants: {
    size: {
      large: 'h-3 bg-neutral-background-lowest',
      medium: 'h-px bg-neutral-border-main'
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});

interface DividerProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof dividerVariants> {}

export const Divider = ({ className, size = 'medium', ...props }: DividerProps) => {
  return <hr className={dividerVariants({ size, className })} {...props} />;
};
